import { selectors } from '@mulesoft/exchange-ui-portals-store';

export function redirectIfDefaultPageEmpty({
  basePath,
  typeDefinition,
  pushFn,
  assetParams
}) {
  return (dispatch, getState) => {
    const state = getState();
    const path = typeDefinition?.routes?.find(
      (route) => route.defaultOnEmptyHome
    )?.path;
    const page = selectors.selectPage(state, assetParams);
    const isAssetHomeEmpty = page.html === '';
    const canEditAsset = selectors.selectCanEditAsset(state, assetParams);

    if (path && isAssetHomeEmpty && !canEditAsset) {
      const targetPath = `${basePath}${path}`;

      pushFn(targetPath);
    }
  };
}
